import styled from 'styled-components';
import React from 'react';
import getCritariaIcon from './getCriteriaIcon';

const CriteriaImageContainer = styled.div`
  background-image: url(${props => props.src});
  box-sizing: inherit;
  width: ${props => (props.small ? '48px' : '60px')};
  height: ${props => (props.small ? '49px' : '60px')};
  background-repeat: no-repeat;
  background-size: contain;
`;

const CriteriaImage = ({
  mountingType,
  mountingPosition,
  iconCombination,
  small = false,
}) => {
  if (iconCombination) {
    const mountingProperties = iconCombination.split('_');
    mountingType = Number(mountingProperties[1]);
    mountingPosition = Number(mountingProperties[0]);
  }

  let criteriaIcon = getCritariaIcon(mountingPosition, mountingType);

  return (
    <CriteriaImageContainer
      src={criteriaIcon}
      small={small}
      alt="criteria-image"
    />
  );
};

export default CriteriaImage;
